import api from '../api'
import axios from '../axios'

class ProductService {
  /**
   * 获取产品列表
   */
  static getList (query) {
    return axios.get(api.reserve.product.homeList, { params: query }).then(res => {
      return Promise.resolve(res.data)
    })
  }

  /**
   * 产品详情
   */
  static getDetail ({ id }) {
    return axios.get(api.reserve.product.detail, { params: { id } }).then(res => {
      return Promise.resolve(res.data.data)
    })
  }

  /**
   * 关注
   */
  static doFollow ({ product_id, status }) {
    return axios.post(api.reserve.product.follow, { product_id, status })
  }

  // 评论
  static doComment ({ product_id, content, pid }) {
    return axios.post(api.reserve.comment.add, { product_id, content, pid })
  }

  // 点赞
  static doPraise (query) {
    return axios.post(api.reserve.comment.credit, query)
  }

  static getCommentList ({ product_id }) {
    // todo
  }

  // 新订单
  static newOrder ({ cart }) {
    return axios.post(api.reserve.order.add, cart).then(res => {
      if (res.data && res.data.code === 1) {
        return Promise.resolve(res.data.data)
      }
      return Promise.reject(new Error('Server Error'))
    })
  }
}

export default ProductService
